<template>
  <div class="template">
    <SiteVitrineDesktop class="template__Desktop" />
    <SiteVitrineMobile class="template__Mobile" />
  </div>
</template>

<script>
import SiteVitrineMobile from '@/components/services/sites-vitrine/SiteVitrineMobile.vue'
import SiteVitrineDesktop from '@/components/services/sites-vitrine/SiteVitrineDesktop.vue'
export default {
  name: 'SiteVitrineView',
  components: {
    SiteVitrineDesktop,
    SiteVitrineMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>